import React, { useState, useEffect } from "react";
import Portfolio from "../components/Portfolio";
import contentService from "../services/contentService";

export default function PortfolioPage() {
  const [portfolioContent, setPortfolioContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPortfolioContent = async () => {
      try {
        const response = await contentService.getPortfolioContent();
        if (response.success) {
          setPortfolioContent(response.data);
        } else {
          setError("Failed to load content");
        }
      } catch (err) {
        setError("Failed to load content");
        console.error("Error fetching portfolio content:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPortfolioContent();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center" role="alert">
        {error}
      </div>
    );
  }

  return <Portfolio content={portfolioContent} />;
}
